import React, { useEffect, useState } from "react";
import styles from "./ProfilePage.module.css";
import ProfileSidebar from "../ProfileSidebar/ProfileSidebar";
import EditProfileInfo from "../EditProfileInfo/EditProfileInfo";
import DeleteProfile from "../DeleteProfile/DeleteProfile";
import NewConsultation from "../NewConsultation/NewConsultation";
import Footer from "../../../Footer";
import ProfileMobileNav from "./ProfileMobileNav/ProfileMobileNav";
import ConsultationHistory from "../ConsultationHistory/ConsultationHistory";


const ProfilePage = () => {
  const [activePage, setActivePage] = useState("consultationHistory");

  const renderContent = () => {
    switch (activePage) {
      case "editInfo":
        return <EditProfileInfo onCancel={() => setActivePage("consultationHistory")} />;
      case "withdrawal":
        return <DeleteProfile onCancel={() => setActivePage("consultationHistory")} />;
      case "newConsultation":
        return <NewConsultation onComplete={() => setActivePage("consultationHistory")} />;
      case "consultationHistory":
      default:
        return <ConsultationHistory />;
    }
  };
  
  return (
    <>
      <div className={styles.profilePageWrapper}>
        <div className={styles.profilePageContainer}>
          <div className={styles.profileLayout}>
            <div className={styles.sidebarWrapper}>
              <ProfileSidebar
                activePage={activePage}
                setActivePage={setActivePage}
              />
            </div>
            <main className={styles.contentArea}>
              <div className={styles.mobileNavWrapper}>
                <ProfileMobileNav
                  activePage={activePage}
                  setActivePage={setActivePage}
                />
              </div>
              {renderContent()}
            </main>
          </div>
        </div>
        <Footer showGetStarted={false} />
      </div>
    </>
  );
};

export default ProfilePage;
